import { Button } from "@bfc-software/pallet";
// eslint-disable-next-line no-restricted-imports -- follow-up: use useCurrentLocalization()
import type { TFunction } from "i18next";

import type { ExportFormat } from "../-data/download";

import styles from "./export-links.module.css";

type Props = {
  onExport: (format: ExportFormat) => void;
  busy: boolean;
  failed: boolean;
  t: TFunction;
};

const FORMATS: ReadonlyArray<ExportFormat> = ["csv", "xlsx"];

/**
 * "CSV  XLSX": the current page of a tab as a file. Pressing one fetches it;
 * a failure says so beside the links rather than in a toast that would be gone
 * before it was read.
 */
export function ExportLinks({ onExport, busy, failed, t }: Props) {
  return (
    <div className={styles.links} data-test-role="drawer-export">
      {failed ? (
        <span role="alert" className={styles.failed}>
          {t("list.exportFailed")}
        </span>
      ) : null}
      {FORMATS.map((format) => (
        <Button
          key={format}
          kind="link"
          variant="accent"
          text={t(`drawer.export.${format}`)}
          isDisabled={busy}
          onPress={() => onExport(format)}
        />
      ))}
    </div>
  );
}
